export const options = [
  {
    name: "splashPage",
    keyTranslate: "headerHelp",
    icon: "icon-question-mark",
    flag: "enableSplashPage",
    disabled: false
  },
  {
    name: "randomize",
    keyTranslate: "tabRandomize",
    icon: "icon-randomize",
    flag: "enableRandomize",
    disabled: false
  },
  {
    name: "transferStyle",
    keyTranslate: "headerTransferStyle",
    icon: "icon-transfer",
    flag: "enableTransferDesign",
    disabled: false,
  },
  {
    name: "finishMyDesign",
    keyTranslate: "headerFinishMyDesign",
    icon: "icon-finish-my-design",
    flag: "enableFinishMyDesign",
    disabled: false
  },
  {
    name: "undo",
    keyTranslate: "headerUndo",
    icon: "icon-undo",
    flag: "enableUndo",
    disabled: false
  },
  {
    name: "startOver",
    keyTranslate: "headerStartOver",
    icon: "icon-redo",
    flag: "enableStartOver",
    disabled: false
  },
  {
    name: "favorite",
    keyTranslate: "headerFavorites",
    icon: "icon-wishlist",
    flag: "enableFavorites",
    disabled: false
  },
  {
    name: "share",
    keyTranslate: "headerShare",
    icon: "icon-share-2",
    flag: "enableShare",
    disabled: false
  },
];
